module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lottery"
  }, [_c('h2', [_vm._v(_vm._s(_vm.lotteryExtended.name))]), _vm._v(" "), _vm._l((_vm.lotteryExtended.sets), function(set, index) {
    return _c('dl', [_c('dt', {
      domProps: {
        "textContent": _vm._s(set.label || 'Set ' + (index + 1))
      }
    }), _vm._v(" "), _c('dd', [_c('ul', {
      staticClass: "set"
    }, _vm._l((set.extended), function(number) {
      return _c('li', {
        staticClass: "set__number",
        class: {
          'drawn': _vm.isDrawn(set, number), 'locked': _vm.isLocked(set, number)
        },
        on: {
          "click": function($event) {
            _vm.toggleLock(set, number, index)
          }
        }
      }, [_vm._v("\n                    " + _vm._s(number) + "\n                ")])
    }))])])
  }), _vm._v(" "), _c('my-button', {
    on: {
      "click": _vm.draw
    }
  }, [_vm._v("Zufallszahlen generieren")])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-29ef1fa0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DrawFromSets.vue
// module id = 78
// module chunks = 1